import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import ModalComponent from '@components/Share/ModalComponent';
import StoreLocatorFilterPopupContent
from '@components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon/StoreLocatorFilterPopupContent';

import { usePickupFromStoreContext } from '../PickupFromStoreContext';

const StoreFilter = () => {
  const settingGlobal = useSelector((state) => state.settingGlobalReducer.settingGlobal);
  const { addressSetting, onSearchStore, onFilterArea, onClearFilter } = usePickupFromStoreContext();
  const [keyword, setKeyWord] = useState('');
  const [isShowPopup, setIsShowPopup] = useState(false);

  const handleToggleFilterModal = useCallback(() => setIsShowPopup(prevState => !prevState), []);

  const handleChangeSearchInput = (event) => {
    const value = event.target.value;

    setKeyWord(value);

    onSearchStore(value.toLowerCase());
  };

  const handleSubmitFilter = useCallback(
    (params) => {
      if (params) {
        if (onFilterArea) onFilterArea(params);
      } else {
        if (onClearFilter) onClearFilter();
      }

      handleToggleFilterModal();
    },
    [onClearFilter]
  );

  return addressSetting ? (
    <div className='store-locator__content__list__search'>
      <div className='store-locator__search__input'>
        <input
          type='text'
          className='form-control form-control-lg store-locator__search__input__item'
          value={keyword}
          onChange={handleChangeSearchInput}
        />
      </div>
      <div className='store-locator__search__btn'>
        <div
          className='store-locator__search__btn__item store-locator__search__btn__item--filter'
          onClick={handleToggleFilterModal}
        >
          <span className='store-locator-icon store-locator-icon--filter'></span>
        </div>
        <ModalComponent
          isShow={isShowPopup}
          titlePopup={settingGlobal?.['FilterStoresLabel']}
          onCloseHandler={handleToggleFilterModal}
          cssClass='search-filter-bar__filter-popup'
        >
          <div className='address-component'>
            <StoreLocatorFilterPopupContent
              dataFields={{
                'Address Settings': addressSetting,
                'Apply Filters Button Label': { value: settingGlobal?.['ApplyFiltersButtonLabel'] },
                'Clear Filters Button Label': { value: settingGlobal?.['ClearFiltersButtonLabel'] }
              }} setSubmitAddressEvt={handleSubmitFilter}
            />
          </div>
        </ModalComponent>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default StoreFilter;